module.exports = __webpack_public_path__ + "img/flndex02.97146d92.png";